import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=595da6ac&scoped=true&"
import script from "./Value.vue?vue&type=script&lang=js&"
export * from "./Value.vue?vue&type=script&lang=js&"
import style0 from "./Value.vue?vue&type=style&index=0&id=595da6ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595da6ac",
  null
  
)

export default component.exports